import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetDiscussionsLoading, EGetDiscussionsActionType } from './types';

export const getDiscussionsLoading: () => TGetDiscussionsLoading = actionGenerator<EGetDiscussionsActionType.Loading>(
  EGetDiscussionsActionType.Loading,
);
